module.exports = __webpack_public_path__ + "static/img/icon_arrowd2.6b42fdc.png";